import { useAuthenticator } from '@aws-amplify/ui-react';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { useEffect, useRef, useState } from 'react';

const User = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const clickOutsideUser = (e: MouseEvent) => {
      if (isOpen && ref.current && !ref.current.contains(e.target as Node)) setIsOpen(false);
    };

    document.addEventListener('mousedown', clickOutsideUser);

    return () => {
      document.removeEventListener('mousedown', clickOutsideUser);
    };
  }, [isOpen]);

  return (
    <div ref={ref}>
      <div className="relative">
        <div className="flex  cursor-pointer" onClick={() => setIsOpen(!isOpen)} data-cy="user-area">
          <UserCircleIcon className="h-10 w-10" />
          <div className="pt-1">{user.getUsername()}</div>
        </div>
        {isOpen && (
          <div className="absolute right-0 top-10  z-50 w-20 rounded border p-2 drop-shadow-2xl">
            <div className="cursor-pointer text-sky-400 underline" onClick={signOut} data-cy="sign-out">
              Sign out
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default User;
